module.exports = __webpack_public_path__ + "img/dz-login-logo.89a4e9e8.png";